export const APP_INTEGRATIONS = 'APP_INTEGRATIONS';
export const ADMINS = 'ADMINS';
export const HUBS = 'HUBS';
export const REVIEW_WRITE = 'REVIEW_WRITE';
export const REVIEWS_FETCH = 'REVIEWS_FETCH';
export const REVIEWS_STATS = 'REVIEWS_STATS';
export const DETAILS_MORE_APPS_FETCH = 'DETAILS_MORE_APPS_FETCH';
export const FEATURE_COMPATIBILITY = 'FEATURE_COMPATIBILITY';